import { BtnWrapper, ContentWrapper, HeaderName, HeaderTittle, HeaderWrapper } from "./Style.ts";
import { Link } from "@/DependenciesV9";
import { useTranslation } from "react-i18next";
import SwitchTenant from "./components/switch-tenant/SwitchTenantContainer.ts"

const Header = () => {
  const { t } = useTranslation();
  return (
    <HeaderWrapper className="LayoutWrapper">
      <ContentWrapper className="LayoutWrContentWrapperapper">
        <HeaderTittle className="HeaderTittle">
          <Link href="">
            OfficePlace
          </Link>
        </HeaderTittle>
        <HeaderName className="HeaderName">
          <span>{t("Tenants")}</span>
        </HeaderName>
      </ContentWrapper>
      <BtnWrapper className="BtnWrapper">
        <SwitchTenant />
      </BtnWrapper>
    </HeaderWrapper>
  );
};

export default Header;